import { render, staticRenderFns } from "./BasicPieChart.vue?vue&type=template&id=47f78234"
import script from "./BasicPieChart.vue?vue&type=script&lang=js"
export * from "./BasicPieChart.vue?vue&type=script&lang=js"
import style0 from "./BasicPieChart.vue?vue&type=style&index=0&id=47f78234&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports